import { AnchorCalculator, ShapeGeoBuilder } from '@jxUml';
import jxLogger from '../../../services/utils/jxLogger';

const _name = 'WaypointUpLeftLine';

/**
 * Single-waypoint L-shape: fromShape exits UP (top border) to the waypoint,
 * waypoint then goes LEFT to toShape (entering toShape's RIGHT border).
 * Hardcoded direction — see WaypointDownRightLine.js for the sibling
 * strategy this was split from, and WaypointStrategySelector.js for the
 * dispatcher.
 * @param {object} connector
 * @param {object} fromShape
 * @param {object} toShape
 */
export function waypointUpLeftLine(connector, fromShape, toShape) {
    const waypoints = connector.points || [];
    if (waypoints.length !== 1) return;
    const waypoint = waypoints[0];

    jxLogger(_name).logDebug(
        'run',
        `connector ${connector.id?.slice(0, 8)} | before | fromShape=${JSON.stringify({ x: fromShape.x, y: fromShape.y, w: fromShape.w, h: fromShape.h })} | toShape=${JSON.stringify({ x: toShape.x, y: toShape.y, w: toShape.w, h: toShape.h })} | waypoint=${JSON.stringify({ x: waypoint.x, y: waypoint.y })} | fromAnchor=${JSON.stringify(connector.fromAnchorPoint)} | toAnchor=${JSON.stringify(connector.toAnchorPoint)}`,
    );

    const toEffectiveH = ShapeGeoBuilder.effectiveHeight(toShape);

    // A manual anchor is clamped to the shape's current bounds rather than
    // reset to center when out of range (e.g. after a collapse) — keeps
    // anchors spread along the border instead of collapsing onto one point.
    const sharedX = connector.fromAnchorPoint
        ? AnchorCalculator.toShape(fromShape, connector.fromAnchorPoint).x
        : fromShape.x + fromShape.w / 2;
    connector.fromAnchorPoint = { x: AnchorCalculator.clamp(sharedX - fromShape.x, 0, fromShape.w), y: 0 };
    waypoint.x = sharedX;

    const sharedY = connector.toAnchorPoint
        ? AnchorCalculator.toShape(toShape, connector.toAnchorPoint).y
        : toShape.y + toEffectiveH / 2;
    connector.toAnchorPoint = { x: toShape.w, y: AnchorCalculator.clamp(sharedY - toShape.y, 0, toEffectiveH) };
    waypoint.y = sharedY;

    jxLogger(_name).logDebug(
        'run',
        `connector ${connector.id?.slice(0, 8)} | after | waypoint=${JSON.stringify({ x: waypoint.x, y: waypoint.y })} | fromAnchor=${JSON.stringify(connector.fromAnchorPoint)} | toAnchor=${JSON.stringify(connector.toAnchorPoint)}`,
    );
}
